import { ViewTable } from './viewTable';

export const mapViewTableToText: Record<ViewTable, string> = {
  [ViewTable.Week]: 'Неделя',
  [ViewTable.Month]: 'Месяц',
};
